if (!customElements.get('bundle-products')) {
  class ProductBundles extends HTMLElement {
    constructor() {
      super()

      this.mainProductId = this.dataset.mainProductId;
      this.mainProductTitle = this.dataset.mainProductTitle;
      this.mainProductUrl = this.dataset.mainProductUrl;
      this.variantSelectors = this.querySelectorAll('select[data-variant-selector]');
      this.variantRadios = this.querySelectorAll('input[type="radio"]');
      this.erroMessageField = this.querySelector('[data-error-message]');
      this.messages = {};

      this.messages.outOfStock = this.dataset.outOfStockMessage;
      this.messages.emptyVariant = this.dataset.emptyVariant;
    }

    connectedCallback() {
      this.attachEvents()
      this.initializeDefaultSelections()
    }

    attachEvents() {
      document.addEventListener('dcb:change-bundle-variant', this.validateVariantAvailable.bind(this));
      document.addEventListener('dcb:submit-bundle', this.validate.bind(this));
    }

    initializeDefaultSelections() {
      // Trigger validation for default selected radio buttons
      this.variantRadios.forEach(radio => {
        if (radio.checked) {
          document.dispatchEvent(new CustomEvent('dcb:change-bundle-variant', {
            detail: {
              id: radio.value,
              variantTitle: radio.dataset.value,
              available: radio.dataset.available || 'true'
            }
          }));
        }
      });

      // Trigger validation for default selected dropdown options
      this.variantSelectors.forEach(select => {
        if (select.value !== '') {
          const selectedOption = select.querySelector(`option[value="${select.value}"]`);
          if (selectedOption) {
            document.dispatchEvent(new CustomEvent('dcb:change-bundle-variant', {
              detail: {
                id: select.value,
                variantTitle: selectedOption.textContent,
                available: selectedOption.dataset.available || 'true'
              }
            }));
          }
        }
      });
    }

    validateVariantAvailable(event) {
      let bundlelHasUnavailableProducts = false;

      // Check select elements
      this.variantSelectors.forEach(variantSelector => {
        if (variantSelector.value == event.detail.id) return;

        const selectedOption = variantSelector.querySelector(`option[value="${variantSelector.value}"]`);
        const availableVariant = selectedOption.dataset.available;

        if (availableVariant === 'false') {
          bundlelHasUnavailableProducts = true;
        }
      });

      // Check radio buttons
      this.variantRadios.forEach(radio => {
        if (radio.value == event.detail.id) return;

        if (radio.checked && radio.dataset.available === 'false') {
          bundlelHasUnavailableProducts = true;
        }
      });

      if (event.detail.available === 'true' && event.detail.variantTitle !== '') {
        if (!bundlelHasUnavailableProducts) {
          document.dispatchEvent(new CustomEvent('dcb:bundle-is-available'));

          this.handleErrorMessage();
        }

        return;
      };

      let message = '';

      if (event.detail.available === 'false') {
        message = this.messages.outOfStock.replace('[[variantTitle]]', event.detail.variantTitle);
      } else if (event.detail.variantTitle === '') {
        message = this.messages.emptyVariant;
      }

      this.handleErrorMessage(message);

      document.dispatchEvent(new CustomEvent('dcb:bundle-is-sold-out'));
    }

    validate() {
      let hasError = false;

      // Simple test: check if any radio buttons are checked at all
      const allRadios = this.querySelectorAll('input[type="radio"]');
      const checkedRadios = Array.from(allRadios).filter(radio => radio.checked || radio.hasAttribute('checked'));

      // If no radio buttons are checked, show error immediately
      if (checkedRadios.length === 0) {
        this.handleErrorMessage(this.messages.emptyVariant);
        return;
      }

      // Only validate select elements if they are visible and have values
      this.variantSelectors.forEach((variantSelector) => {
        // Skip validation for hidden select elements (used in carousel layout)
        if (variantSelector.closest('.bundle-product__inner') &&
            variantSelector.closest('.bundle-product__inner').style.display === 'none') {
          return;
        }


        if (variantSelector.value === '') {
          this.handleErrorMessage(this.messages.emptyVariant);
          hasError = true;
          return;
        }

        const selectedOption = variantSelector.querySelector(`option[value="${variantSelector.value}"]`);
        if (!selectedOption) {
          this.handleErrorMessage(this.messages.emptyVariant);
          hasError = true;
          return;
        }

        const variantTitle = selectedOption.textContent;
        const availableVariant = selectedOption.dataset.available;

        if (availableVariant === 'false') {
          this.handleErrorMessage(this.messages.outOfStock.replace('[[variantTitle]]', variantTitle));
          hasError = true;
          return;
        }
      });

      const radioGroups = new Map();
      allRadios.forEach(radio => {
        if (!radioGroups.has(radio.name)) {
          radioGroups.set(radio.name, []);
        }
        radioGroups.get(radio.name).push(radio);
      });

      radioGroups.forEach((radios) => {

        // Check for both checked property and checked attribute
        const checkedRadio = radios.find(radio => radio.checked || radio.hasAttribute('checked'));

        if (!checkedRadio) {
          this.handleErrorMessage(this.messages.emptyVariant);
          hasError = true;
          return;
        }

        // Only check availability if data-available is present
        if (checkedRadio.dataset.available === 'false') {
          this.handleErrorMessage(this.messages.outOfStock.replace('[[variantTitle]]', checkedRadio.dataset.value));
          hasError = true;
          return;
        }
      });

      if (!hasError) {
        this.handleErrorMessage();
        document.dispatchEvent(new CustomEvent('dcb:bundle-is-valid', { detail: { mainProductId: this.mainProductId, mainProductTitle: this.mainProductTitle, mainProductUrl: this.mainProductUrl, variants: this.variantSelectors }}));
      }
    }

    handleErrorMessage(message = '') {
      if (message === '') {
        this.erroMessageField.classList.add('hidden');

        return;
      }

      this.erroMessageField.textContent = message;

      this.erroMessageField.classList.remove('hidden');
    }
  }

  customElements.define('bundle-products', ProductBundles)
}

